import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: 'rgba(76, 125, 255, 0.18)',
} as const

export const resources = {
  loginBg: '/images/moonpage/login/login-bg.webp',
  logo: '/images/moonpage/login/moonpage-logo.svg',
  novel: '/images/moonpage/login/moonpage-novel.svg',
  facebookIcon: '/images/moonpage/login/icon-facebook-logo.png',
  googleIcon: '/images/moonpage/login/icon-google-logo-moonpage.svg',
  appleIcon: '/images/moonpage/login/icon-apple-logo-moonpage.svg',
  emailIcon: '/images/moonpage/login/icon-email.png',
  emailCodeIcon: '/images/moonpage/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
